import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_jrnl_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  amount_debit: fromDatatype.MoneyDatatypeInterface;
  amount_credit: fromDatatype.MoneyDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_guid: fromDatatype.GuidDataFieldInterface;
  segment_guid: fromDatatype.GuidDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  dimension_guid: fromDatatype.GuidDataFieldInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  tx_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_generic_doc_jrnl_line_RowClass
  implements bl_fi_generic_doc_jrnl_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  amount_debit: fromDatatype.MoneyDatatypeInterface;
  amount_credit: fromDatatype.MoneyDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_guid: fromDatatype.GuidDataFieldInterface;
  segment_guid: fromDatatype.GuidDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  dimension_guid: fromDatatype.GuidDataFieldInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  tx_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
